module.exports = __webpack_public_path__ + "img/vertical_4_2_8019.8c5be978.png";